import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";
import { useScrolled } from "../hooks/useReveal";
import logo from "../assets/krs-logo-transparent.png";

export default function Navbar() {
  const scrolled = useScrolled(30);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const solid = scrolled || open;
  const textColor = solid ? "text-navy" : "text-cream";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${solid ? "bg-cream/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)] py-4" : "bg-transparent py-6"}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="KRS Design and Renovation"
            className={`w-auto object-contain transition-all duration-500 ${solid ? "h-14 md:h-16" : "h-16 md:h-20 drop-shadow-[0_2px_12px_rgba(0,0,0,0.5)]"}`}
          />
        </Link>

        {/* Desktop / Tablet nav */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-9 md:mt-3 lg:mt-0 self-start md:self-center">
          {NAV_LINKS.map((l) => {
            const active = location.pathname === l.path;
            return (
              <Link
                key={l.path}
                to={l.path}
                className={`link-underline font-sans text-[13px] lg:text-[12px] tracking-wide-nav uppercase transition-colors duration-300 ${textColor} ${active ? "opacity-100" : "opacity-80 hover:opacity-100"}`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            to="/contact"
            className={`hidden lg:inline-flex items-center px-6 py-3 font-sans text-[11px] tracking-wide-nav uppercase transition-all duration-300 ${solid ? "bg-navy text-cream hover:bg-gold hover:text-navy" : "bg-gold text-navy hover:bg-cream"}`}
          >
            Start Your Project
          </Link>
          <button className={`md:hidden ${textColor}`} onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden fixed inset-0 top-[68px] bg-cream transition-transform duration-500 ${open ? "translate-x-0" : "translate-x-full"}`}>
        <nav className="flex flex-col px-8 py-10 gap-2">
          {NAV_LINKS.map((l) => (
            <Link key={l.path} to={l.path} className="font-serif text-3xl text-navy py-3 border-b border-cream-dark">
              {l.label}
            </Link>
          ))}
          <Link to="/contact" className="mt-6 bg-navy text-cream text-center py-4 font-sans text-[12px] tracking-wide-nav uppercase">
            Start Your Project
          </Link>
        </nav>
      </div>
    </header>
  );
}
